import app from '@/entries/main';
import BlueCheckout from '@/components/BlueCheckout.vue';
import CheckoutRegisterPassword from '@/components/BlueCheckout/CheckoutRegisterPassword.vue';
import AddToCartButton from '@/components/BlueAction/AddToCartButton.vue';
import CartDisplay from '@/components/Blue/Cart/CartDisplay.vue';
import BlueFreeShipmentInfo from '@/components/Blue/ProductDescription/blue-free-shipment-info.vue';
import BlueShippingPeriodInfo from '@/components/Blue/ProductDescription/BlueShippingPeriodInfo.vue';
import StickyCtaRow from '@/components/Base/StickyCtaRow.vue';
import { useStore } from '@/store';
import eventBus from '@/services/EventBus';
import DealProductsWrapper from '@/components/Blue/DealProductsWrapper.vue';
import ProductDetailPageContent from '@/components/Blue/ProductDetailPage/ProductDetailPageContent.vue';
import HeaderMenuProductDetailPage from '@/components/Blue/ProductDetailPage/Modules/HeaderMenuProductDetailPage.vue';
import ProductsWrapper from '@/components/Blue/ProductListing/ProductsWrapper.vue';
import FilterIndicatorsAll from '@/components/Blue/ProductListing/FilterIndicatorsAll.vue';
import ListingFilters from '@/components/Blue/ProductListing/ListingFilters.vue';
import MobileFilterHeaderMenu from '@/components/Blue/ProductListing/MobileFilterHeaderMenu.vue';
import ProductBox from '@/components/Blue/ProductBox.vue';
// Popups:
import GuaranteePopup from '@/components/PopUps/GuaranteePopup/GuaranteePopup.vue';
app.component('blue-checkout', BlueCheckout);
app.component('checkout-register-password', CheckoutRegisterPassword);
app.component('blue-add-product-button', AddToCartButton);
app.component('blue-cart-display', CartDisplay);
app.component('blue-free-shipment-info', BlueFreeShipmentInfo);
app.component('blue-shipping-period-info', BlueShippingPeriodInfo);
app.component('sticky-cta-row', StickyCtaRow);
app.component('deal-products-wrapper', DealProductsWrapper);
app.component('header-menu-product-detail-page', HeaderMenuProductDetailPage);
app.component('product-detail-page-content', ProductDetailPageContent);
app.component('products-wrapper', ProductsWrapper);
app.component('filter-indicators-all', FilterIndicatorsAll);
app.component('listing-filters', ListingFilters);
app.component('mobile-filter-header-menu', MobileFilterHeaderMenu);
app.component('product-box', ProductBox);
app.component('guarantee-popup', GuaranteePopup);
require('@legacy/wishlist.js');
app.mount('#app');
eventBus.on('user_set_to_store', () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    useStore().dispatch('account/LOAD_WISHLIST');
});
